define([], function () {

    let accur = 2;
    return class Progress {

        constructor(node) {
            this.node = node;
            this.node.style.width = '10%';
            this.wrap = node.parentNode;
        }

        loadFinish() {
            this.node.style.width = "100%";
            this.node.style.transition = "all 0.6s";
            clearInterval(this.interval);
        }

        reset() {
            this.node.style.width = '10%';
        }

        startLoading(requests_count) {
            let initTimes = Math.round(requests_count/accur);
            let times = initTimes > 4 ? initTimes : 4;

            let oneTick = 100 / times;
            let prev = 5;
            let ticks = 1;

            let ticksFun = () => {

                if (ticks < times) {

                     prev = (prev + oneTick);
                     if (prev >= 95) {
                         prev = 98;
                         clearInterval(this.interval);
                     }
                     this.node.style.width = prev + "%";
                     ticks++;

                } else {

                    clearInterval(this.interval);

                }

            };

            ticksFun();
            this.interval = setInterval(ticksFun, 400 );

        }

    }
});
